export default {
      id: "status_approved-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#status_approved",
      toString: function () {
        return this.url;
      }
    }